module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store_fr-bf2923e12f951f27be7796e486665fc0.png";